import Page from 'components/Page';
import React from 'react';
import Marca from './../assets/img/logo/marca.png';
import Ucsc from './../assets/img/logo/marca-ucsc.jpg';

import {
  Card,
  CardBody,
} from 'reactstrap';

import Cargando from './../components/Cargando';


const Inicio = () => {
  return (
    <Page >

        <Cargando />

        <Card>
            <CardBody className="text-center">
              <br/><br/><br/>
                <img src={Marca} className="img-responsive" alt="Escuela de talentos"/><br/>
                <img src={Ucsc} className="img-responsive" alt="UCSC"/>
                <br/><br/><br/>
            </CardBody>
        </Card>

        <br/>

    </Page>
  );
};

export default Inicio;
